import React from 'react'

import { ChartConfigObject } from '../../../types/shared'
import ChartModel from '../../models/chart'
import ChartLayout from '../../models/chart_layout'
import { DrawingTool } from '../toolbar/interfaces'

export const CHART_CLASS_NAMES = 'chart flex-1 dark:bg-gray-800 relative'
export const DEFAULT_WRAPPER_COMPONENT = 'div'

export interface ChartProps {
  chartIndex: number
  gridArea?: string
  WrapperComp?: React.RefForwardingComponent<any>
  config: ChartConfigObject
  chartModel: ChartModel
  layoutModel: ChartLayout
  setActiveChartInteraction: (interaction: string | null) => void
  activeChartInteraction: string | null
  activeTool: DrawingTool
  touchEventsDisabled: boolean
  hasOutline?: boolean
  shouldResize?: boolean
  renderChartToolbar?: () => React.ReactNode
}
